var ErrorList = /* @__PURE__ */ ((ErrorList2) => {
  ErrorList2["USAGE_BEFORE_INIT"] = "Usage before init";
  ErrorList2["INVALID_PARAM"] = "Invalid param";
  ErrorList2["INVALID_USER_INFO"] = "Empty user info";
  ErrorList2["INVALID_RESPONSE"] = "Invalid response";
  ErrorList2["ENTITY_MAX_PAGE_SIZE"] = "Max page size for entity is 20. If you need to fetch all, remove page size & page token settings";
  return ErrorList2;
})(ErrorList || {});
export {
  ErrorList
};
